export default "__VITE_ASSET__DXHstBfo__"